import { Controller, useFormContext, useWatch } from 'react-hook-form';

//components
import { showConfirmModal } from 'actions/global';
import BWAccordion from 'components/shared/BWAccordion/index';
import DataTable from 'components/shared/DataTable/index';
import { msgError } from 'pages/Calendar/helpers/msgError';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import ProductModel from './modal/ProductModel/ProductModel';

const Products = ({ disabled }) => {
  const dispatch = useDispatch();
  const methods = useFormContext({});
  const { control } = methods;

  const [openModel, setOpenModel] = useState(false);

  const handleOpenModel = () => {
    setOpenModel(true);
  };

  const handleCloseModel = () => {
    setOpenModel(false);
  };

  const products = useWatch({ name: 'products' });

  const handleDelete = (row, index) => {
    dispatch(
      showConfirmModal(msgError['model_error'], () => {
        const newProducts = products.filter((item, idx) => index !== idx);
        methods.setValue('products', newProducts);
      }),
    );
  };

  const columns = [
    {
      header: 'STT',
      classNameHeader: 'bw_text_center bw_w1',
      classNameBody: 'bw_text_center',
      formatter: (p, idx) => <b className='bw_sticky bw_name_sticky'>{idx + 1}</b>,
    },
    {
      header: 'Mã sản phẩm',
      accessor: 'product_code',
      formatter: (p) => <b className='bw_sticky bw_name_sticky'>{p?.product_code}</b>,
    },
    {
      header: 'Tên sản phẩm',
      accessor: 'product_name',
    },
    {
      header: 'Loại',
      classNameHeader: 'bw_text_center',
      classNameBody: 'bw_text_center',
      accessor: 'product_type',
      formatter: (p) => {
        if (p?.product_type === 2) {
          return <span className='bw_label bw_label_success'>Linh kiện</span>;
        } else {
          return <span className='bw_label bw_label_danger'>Sản phẩm</span>;
        }
      },
    },
  ];

  const actions = [
    {
      icon: 'fi fi-rr-trash',
      color: 'red',
      permission: ['SL_ORDERS_ADD', 'SL_ORDERS_EDIT'],
      disabled: disabled,
      onClick: handleDelete,
    },
  ];

  return (
    <BWAccordion title='Danh sách sản phẩm tặng kèm' id='bw_info_cus'>
      {!disabled && (
        <div className='bw_row bw_align_items_center' disabled={!methods.watch('stock_id')}>
          <div className='bw_col_4'>
            {/* <input type='text' placeholder='Nhập mã barcode/mã sản phẩm/tên sản phẩm' className='bw_inp' /> */}
          </div>
          <div className='bw_col_8' style={{ flexWrap: 'nowrap' }}>
            <div className='bw_btn_group bw_btn_grp bw_flex bw_align_items_center bw_justify_content_right'>
              <a className='bw_btn bw_btn_success bw_open_modal' onClick={handleOpenModel}>
                <span className='fi fi-rr-plus'></span> Chọn sản phẩm
              </a>
            </div>
          </div>
        </div>
      )}
      <Controller
        control={control}
        name='products'
        render={({ field: { value = [], onChange }, fieldState: { error } }) => (
          <>
            <DataTable columns={columns} data={value} actions={actions} noPaging={true} noSelect={true} />
            {/* {error && <ErrorMessage message={error?.message} />} */}

            {openModel && (
              <ProductModel open={openModel} onClose={handleCloseModel} onChange={onChange} value={value} />
            )}
          </>
        )}
      />
    </BWAccordion>
  );
};

export default Products;
